<template>
  <TheLayout :showHomeLink="showHomeLink">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col" class="text-end">Aktionen</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="tenant in tenants" :key="tenant.Oid">
            <td>{{ tenant.Matchcode }}</td>
            <td class="text-end">
              <button v-if="activeTenant === tenant.Oid" class="btn btn-success disabled">aktiv</button>
              <button @click="setTenantId(tenant.Oid)" v-else class="btn btn-secondary">Auswählen</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </TheLayout>
</template>

<script setup>
import { useStore } from "vuex";
import TheLayout from "@/layouts/TheLayout.vue";
import {computed} from "vue";
import {useRoute} from "vue-router";

const route = useRoute();
const store = useStore();

const tenants = computed(() => store.getters.tenantsSortedByNameAsc);
const activeTenant = computed(() => store.getters.tenantId);

const showHomeLink = computed(() => route.query.showHomeLink === "1");

const setTenantId = (tenantId) => {
    store.commit("setTenantId", tenantId);
    store.dispatch("loadDetectors");
};

</script>

<style scoped>

</style>